import React from 'react';
import { Button, ButtonProps } from '@mantine/core';

interface LoadingButtonProps extends Omit<ButtonProps, 'leftSection'>, Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof ButtonProps> {
    loading?: boolean;
    icon?: React.ReactNode;
    loadingText?: string;
    children: React.ReactNode;
    loadingIcon?: React.ReactNode;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
    loading = false,
    icon,
    loadingText,
    children,
    disabled,
    loadingIcon: _loadingIcon,
    ...buttonProps
}) => {
    const displayText = loading && loadingText ? loadingText : children;

    return (
        <Button
            {...buttonProps}
            disabled={disabled || loading}
            loading={loading}
            leftSection={!loading ? icon : undefined}
        >
            {displayText}
        </Button>
    );
};
